import { Input } from 'antd';
import * as React from 'react';
import DistrictUserApiService from '../../api/DistrictUserApiService';
import * as SearchForDistrictUserHandler from '../../handlerModels/SearchForDistrictUserHandler';
import UserDTO from '../../models/UserDTO';
import AutoCompleteInput, { AutoCompleteInputOption } from './AutoCompleteInput';

interface DistrictUserSearchInputProps {
  districtIdentifier: number;
  academicYear: number;
  value?: UserDTO | null;
  disabled?: boolean;
  onChange?: (value: UserDTO | null) => void;
}

function DistrictUserSearchInput(props: React.PropsWithChildren<DistrictUserSearchInputProps>) {

  const [options, setOptions] = React.useState([] as AutoCompleteInputOption[]);
  const [users, setUsers] = React.useState([] as UserDTO[]);
  const [selectedUser, setSelectedUser] = React.useState(props.value as UserDTO | null);
  const [searching, setSearching] = React.useState(false);

  const handleSearch = (value: string) => {
    if (value.length > 2) {
      const request = SearchForDistrictUserHandler.Request.create(
        {
          districtIdentifier: props.districtIdentifier,
          academicYear: props.academicYear,
          searchString: value
        });
      setSearching(true);

      DistrictUserApiService.searchDistrictUsers(request)
        .then((x: SearchForDistrictUserHandler.Result) => {
          const options = x.users?.map(x => ({
            value: x.id,
            display: x.fullDisplay
          } as AutoCompleteInputOption)) as AutoCompleteInputOption[];

          setUsers(x.users ?? []);
          setOptions(options);
          setSearching(false);
        });
    }
  }

  const handleChange = (value: string) => {
    const selected = users.find(x => x.id == value) ?? null;
    setSelectedUser(selected);
    if (props.onChange) {
      props.onChange(selected);
    }
  }

  return (
    <Input.Group compact>
      <label title={'District User Search'} htmlFor={'districtUser'} />
      <AutoCompleteInput id='districtUser' disabled={props.disabled} initialValue={props.value?.display} value={selectedUser} options={options} onSearch={handleSearch} onChange={handleChange} searching={searching} />
    </Input.Group>
  );
}
export default DistrictUserSearchInput;
